var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"10876"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/dashboard";

import * as Sentry from '@sentry/nextjs'
import { RewriteFrames } from "@sentry/integrations";

const SENTRY_DSN = process.env.SENTRY_DSN

Sentry.init({
  dsn: SENTRY_DSN || "https://eee67843d5134577905a5f5b2201fbe0@o137663.ingest.sentry.io/1467255",
  integrations: [new RewriteFrames()],
  tracesSampleRate: 0.05,
  attachStacktrace: true,
  maxBreadcrumbs: 50,
  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications.',
    'Failed to execute \'insertBefore\' on \'Node\': The node before which the new node is to be inserted is not a child of this node'
  ],
  environment: process.env.SENTRY_ENVIRONMENT,
  release: process.env.SENTRY_RELEASE,
  enabled: process.env.NODE_ENV === 'production',
  debug: false,
  // Do we need these?
  // replaysOnErrorSampleRate: 1.0,
  // replaysSessionSampleRate: 0.05,
})
